import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ICartorioDetail } from "../interface/cartorio/ICartorioDetail";
import { ITrade } from "../interface/trade/ITrade";

enum CartorioServiceEnum {
  getAll = "/",
  save = "/",
  getById = "/",
  requestDigitalCertificate = "/request-digital-certificate/"
}

export default class CartorioService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/cartorio");
  }

  public getAll = async (): Promise<ICartorioDetail[]> => await this.GET(CartorioServiceEnum.getAll);
  public getById = async (id: number): Promise<ICartorioDetail> => await this.GET(CartorioServiceEnum.getById + id);
  public save = async (data: ICartorioDetail): Promise<ICartorioDetail> => await this.POST(CartorioServiceEnum.save, data);
  public requestDigitalCertificate = async (idTrade: number): Promise<ITrade> => await this.GET(CartorioServiceEnum.requestDigitalCertificate + idTrade);
}
